// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { change } from 'redux-form'

// takes the selected contact and adds it to the multiselect in the search form.
// ignoring if the selected contact was already stored
// adding to the list if not
const assignContact = (selectedContact, sourceForm) => (dispatch, getState) => {
  const { form } = getState()

  const {
    contactId: storedContacts,
  } = form[sourceForm].values

  // if the selected contact is already stored, don't add it again
  if (storedContacts.find(c => c.contactId === selectedContact.contactId)) {
    return
  }

  const contactId = [
    ...storedContacts,
    selectedContact,
  ]

  dispatch(change(sourceForm, 'contactId', contactId))
}

export default assignContact
